module.exports = __webpack_public_path__ + "img/Leren Leren Logo.123d9e9e.png";